module.exports = __webpack_public_path__ + "img/music-icon-blue.45fd614a.png";